import Card from '@material-ui/core/Card'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import classNames from 'classnames'
import {toUpper} from 'lodash'
import {Trans, WithNamespaces, withNamespaces} from 'react-i18next'
import messages from '../../../../../assets/messages'
import {withStyles} from '@material-ui/core'
import {ClassNameMap} from '@material-ui/core/styles/withStyles'
import {styles} from './styles'
import {MT5Badge} from './components/MT5Badge'
import {MT4Badge} from './components/MT4Badge'
import {AccountType} from './types'
import {caption} from './helpers'
import {Client} from '../../../../../graphql/types'
import {getAccountSubtype, getAccountSubtypeLabel} from '../../../../../common/utils/accounts'

export type {AccountType}

type AccountTypeItemProps = {
  account: AccountType
  classes?: Partial<ClassNameMap<keyof ReturnType<typeof styles>>>
  hideBadge?: boolean
  key: React.Key
  viewer?: Client
  onSelectAccount: (accountType: string, accountSubtype: string) => void
} & WithNamespaces

const _AccountTypeItem = ({account, classes, hideBadge, onSelectAccount, t, viewer}: AccountTypeItemProps) => {
  const accountSubtype = getAccountSubtype(account.accountSubtype as any)
  const displayLabel = getAccountSubtypeLabel(accountSubtype, viewer) || account.label

  return (
    <Card
    classes={{root: classes?.cardRoot}}
    className={classes?.pointer}
    onClick={() => onSelectAccount(account.accountType, account.accountSubtype)}
  >
      <Grid container>
        <Grid item xs={2} className={classes?.badgeDiv}>
          <div
          className={classNames(
            classes?.typeBadge,
            classes?.[account.subCategory] ||
              classes?.[account.accountSubtype] ||
              classes?.[account.category],
          )}
        >
            {account.icon}
          </div>
        </Grid>
        <Grid item xs={10}>
          <Typography variant="subtitle1" className={classes?.label}>
            {account.showDemoLabel ? `${toUpper(t(messages.demo.i18nKey))} ` : ''}
            {displayLabel}
            {
              <Typography variant="caption" className={classes?.availableAccounts}>
                {account.available && account.maxAllowed > 1 && (
                <Trans
                  {...messages.availableAccounts}
                  values={{available: account.available, maxAllowed: account.maxAllowed}}
                />
              )}
                {account.category === 'forexMt5' && !hideBadge && (
                <MT5Badge>
                  <Trans {...messages.mt5Account} />
                </MT5Badge>
              )}
                {account.category === 'forexMt4' && !hideBadge && (
                <MT4Badge>
                  <Trans {...messages.mt4Account} />
                </MT4Badge>
              )}
              </Typography>
          }
          </Typography>
          <Typography variant="caption">{caption(account, t)}</Typography>
        </Grid>
      </Grid>
    </Card>
  )
}

export const AccountTypeItem = withNamespaces()<AccountTypeItemProps>(
  withStyles(styles)(_AccountTypeItem),
)
